import * as React from 'react';
import {
    LeadershipProfileForm,
    type ProfileFormFlowConfig,
} from 'features/DigitalMarketing/pages/EditWebsiteContent/LeadershipProfiles/LeadershipProfileForm';

const facultyProfileFormFlowConfig: ProfileFormFlowConfig = {
    breadcrumbLabel: 'Faculty Profiles',
    listSubPath: 'faculty-profiles',
    nameLabel: 'First Name',
    namePlaceholder: 'Enter First Name',
    nameRequiredMessage: 'First name is required',
    api: {
        resource: 'faculty' as const,
        create: '/master/upsertFaculty',
        edit: '/master/upsertFaculty',
        indexParam: 'staff_id',
    },
};

export function FacultyProfileForm() {
    return <LeadershipProfileForm config={facultyProfileFormFlowConfig} />;
}
